import { HomePageController } from './page/home_page.controller';
import { IControllerConstructor } from 'angular';

export const initialise = () => {
  angular.module('app.home', [
    'app.layout'
  ])
    .controller('HomePageController', <IControllerConstructor>HomePageController);
};
